import { Input } from "antd"
import React, { useEffect, useRef } from "react"

/* ROUTES */
export const ADMIN_LOGIN_ROUTE = "/login"
export const ADMIN_SHIPMENTS_ROUTE = "/shipments"
export const ADMIN_RESERVATION_LIST_ROUTE = "/reservation-list"
export const ADMIN_PURCHASES_ROUTE = "/purchases"
export const ADMIN_CUSTOMERS_ROUTE = "/customers"
export const ADMIN_PRODUCTS_ROUTE = "/products"
export const ADMIN_PRODUCTS_SORT_ROUTE = "/products-sort"
export const ADMIN_PRODUCTS_STOCK_ROUTE = "/products-stock"
export const ADMIN_NOTIFICATION_SETTINGS_ROUTE = "/notification-settings"
export const ADMIN_PICKUP_SETTINGS_ROUTE = "/pickup-settings"
export const ADMIN_SHIPMENT_SETTINGS_ROUTE = "/shipment-settings"
export const ADMIN_POINT_SETTINGS_ROUTE = "/point-settings"
export const ADMIN_RICHMENU_SETTINGS_ROUTE = "/richmenu-settings"
export const ADMIN_TAX_SETTINGS_ROUTE = "/tax-settings"

export const NOT_FOUND_ROUTE = "/404"
export const PERMISSION_ERROR_ROUTE = "/401"

/* RESPONSE TYPE */
export const RESPONSE_PERMISSION_ERROR = 401
export const RESPONSE_SESSION_ERROR = 403
export const RESPONSE_CONFLICT_ERROR = 409
export const RESPONSE_SYSTEM_ERROR = 500

/* MESSAGE KEY */
export const MESSAGE_SESSION_ERROR_KEY = "SESSION_ERROR"
export const MESSAGE_SYSTEM_ERROR_KEY = "SYSTEM_ERROR"

/* ALERT MESSAGES */
export const ERROR_SYSTEM_MSG = "システムエラー"
export const ERROR_SESSION_MSG = "もう一度ログインしてください"
export const ERROR_401_MSG = "許可が足りないです。"
export const ERROR_404_MSG = "アクセスしたページは存在しません"
export const SUCCESS_LOGIN_MSG = "ログインしました。"
export const SUCCESS_LOGOUT_MSG = "ログアウトしました。"
export const SUCCESS_RESET_MSG = "ポイントをリセットしました。"
export const SUCCESS_CREATE_MSG = "作成しました。"
export const SUCCESS_REGISTER_MSG = "登録しました。"
export const SUCCESS_UPDATE_MSG = "変更しました。"
export const SUCCESS_SAVE_MSG = "保存しました。"
export const SUCCESS_IMPORT_MSG = "インポートしました。"
export const SUCCESS_CONFIRM_MSG = "確認しました。"
export const SUCCESS_SYNC_MSG = "同期しました。"
export const SUCCESS_DELETE_MSG = "削除しました。"
export const WARN_IMAGE_TOO_BIG = "画像サイズが大きすぎます"
export const WARN_DATE_OVER_YEAR = "1年以内の期間を入力してください"
export const WARN_IMAGE_SIZE_DIFFERENT = "画像サイズが違います"
export const SUCCESS_MESSAGE_SENT_MSG = "メッセージを送信しました。"

// COMMON CONSTANTS
export const PRIMARY_COLOR = "#f6ab00"
export const CURRENCY = "¥"
export const POINT_SYMBOL = "P"

/* MESSAGE TYPE */
export const MESSAGE_TYPE_TEXT = "text"

// COUNTRY CONSTANTS
export const COUNTRY_SA = "南米"
// export const COUNTRY_CA = "中米"
export const COUNTRY_NACA = "北中米"
export const COUNTRY_AFRICA = "アフリカ"
export const COUNTRY_ASIA_OTHERS = "アジア、その他"
export const COUNTRIES = [
  COUNTRY_SA,
  // COUNTRY_CA,
  COUNTRY_NACA,
  COUNTRY_AFRICA,
  COUNTRY_ASIA_OTHERS,
]

// ROAST CONSTANTS
export const ROAST_RAW = "生豆"
export const ROAST_LIGHT = "浅煎り"
export const ROAST_MEDIUM = "中煎り"
export const ROAST_MEDIUM_DARK = "中深煎り"
export const ROAST_DARK = "深煎り"
export const ROASTS = [
  ROAST_RAW,
  ROAST_LIGHT,
  ROAST_MEDIUM,
  ROAST_MEDIUM_DARK,
  ROAST_DARK,
]
/* THEME COLOR */
// export const PRIMARY_COLOR = "#99CA29"
export const PRIMARY_LIGHT_COLOR = "#fdfff0"
export const SECONDARY_COLOR = "#21acd7"
export const SECONDARY_LIGHT_COLOR = "#f0feff"
export const THIRD_COLOR = "#fa8c16"
export const THIRD_LIGHT_COLOR = "#fff7e6"
export const CUSTOM_GREEN = "#8ac926"
export const CUSTOM_LIGHT_GREEN = "#fcfff0"
export const CUSTOM_RED = "#ff595e"
export const CUSTOM_LIGHT_RED = "#fff2f0"
export const CUSTOM_YELLOW = "#FAD717"
export const CUSTOM_LIGHT_YELLOW = "#FEFBE8"
export const CUSTOM_GRAY_COLOR = "#d9d9d9"
export const CUSTOM_CAMPAIGN_COLOR = "#960E0E"
export const GRAY_COLOR = "#9CA3AF"
export const WHITE_COLOR = "#FFF"
export const BLACK_COLOR = "#000"
export const SATURDAY_COLOR = "#00c2ff"
export const SUNDAY_COLOR = "#c40055"
// GRIND CONSTANTS
export const GRIND_BEAN = "豆"
export const GRIND_FINE = "細挽き"
export const GRIND_MEDIUM = "中挽き"
export const GRIND_COARSE = "粗挽き"
export const GRINDS = [GRIND_BEAN, GRIND_FINE, GRIND_MEDIUM, GRIND_COARSE]

// TASTE CONSTANTS
export const TASTE_WEAK_SOUR = "酸味弱い"
export const TASTE_STRONG_SOUR = "酸味強い"
export const TASTE_WEAK_BITTER = "苦み弱い"
export const TASTE_STRONG_BITTER = "苦み強い"
export const TASTE_WEAK_SWEET = "甘み弱い"
export const TASTE_STRONG_SWEET = "甘み強い"
export const TASTE_DEEP = "コク深め"
export const TASTE_RICH = "濃厚"
export const TASTE_MELLOW = "まろやか"
export const TASTE_REFRESHING = "スッキリ"
export const TASTE_SHARP = "キレがある"
export const TASTE_FRUITY = "フルーティー"
export const TASTE_COE = "COE（カップオブエクセレンス）"
export const TASTES = [
  TASTE_WEAK_SOUR,
  TASTE_STRONG_SOUR,
  TASTE_WEAK_BITTER,
  TASTE_STRONG_BITTER,
  TASTE_WEAK_SWEET,
  TASTE_STRONG_SWEET,
  TASTE_DEEP,
  TASTE_RICH,
  TASTE_MELLOW,
  TASTE_REFRESHING,
  TASTE_SHARP,
  TASTE_FRUITY,
  TASTE_COE,
]

export const IS_DISPLAYED_BOTH_TEXT = "すべて"
export const IS_DISPLAYED_BOTH_VALUE = undefined
export const IS_DISPLAYED_DISPLAYED_TEXT = "表示"
export const IS_DISPLAYED_DISPLAYED_VALUE = true
export const IS_DISPLAYED_HIDDEN_TEXT = "非表示"
export const IS_DISPLAYED_HIDDEN_VALUE = false
export const IS_DISPLAYED_TYPES = [
  { value: IS_DISPLAYED_BOTH_VALUE, text: IS_DISPLAYED_BOTH_TEXT },
  { value: IS_DISPLAYED_DISPLAYED_VALUE, text: IS_DISPLAYED_DISPLAYED_TEXT },
  { value: IS_DISPLAYED_HIDDEN_VALUE, text: IS_DISPLAYED_HIDDEN_TEXT },
]

//PURCHASE STATUS CONSTANTS
export const PURCHASE_STATUS_INCOMPLETE_VALUE = "incomplete"
export const PURCHASE_STATUS_INCOMPLETE_TEXT = "決済中"
export const PURCHASE_STATUS_INCOMPLETE_OR_LINK_GENERATE_TEXT =
  "決済中・リンク発行中"
export const PURCHASE_STATUS_INCOMPLETE_COLOR = "#91d5ff"
// export const PURCHASE_STATUS_LINK_GENERATE_VALUE = "linkGenerated"
export const PURCHASE_STATUS_LINK_GENERATE_TEXT = "リンク発行中"
export const PURCHASE_STATUS_LINK_GENERATE_COLOR = "#1890ff"
export const PURCHASE_STATUS_CANCELED_VALUE = "cancelled"
export const PURCHASE_STATUS_CANCELED_TEXT = "削除"
export const PURCHASE_STATUS_CANCELED_COLOR = "#fa541c"
export const PURCHASE_STATUS_EXPIRED_TEXT = "期限切れ"

export const PURCHASE_STATUS = [
  {
    value: PURCHASE_STATUS_INCOMPLETE_VALUE,
    label: PURCHASE_STATUS_INCOMPLETE_TEXT,
    color: PURCHASE_STATUS_INCOMPLETE_COLOR,
    class: "hover:bg-custom-light-blue hover:text-white",
  },
  {
    value: PURCHASE_STATUS_CANCELED_VALUE,
    label: PURCHASE_STATUS_CANCELED_TEXT,
    color: PURCHASE_STATUS_CANCELED_COLOR,
    class: "hover:bg-custom-volcano hover:text-white",
  },
]
export const PURCHASE_STATUS_QUERY = [
  {
    value: PURCHASE_STATUS_INCOMPLETE_VALUE,
    label: PURCHASE_STATUS_INCOMPLETE_OR_LINK_GENERATE_TEXT,
    color: PURCHASE_STATUS_INCOMPLETE_COLOR,
    class: "hover:bg-custom-light-blue hover:text-white",
  },

  {
    value: PURCHASE_STATUS_CANCELED_VALUE,
    label: PURCHASE_STATUS_EXPIRED_TEXT,
    color: PURCHASE_STATUS_CANCELED_COLOR,
    class: "hover:bg-custom-volcano hover:text-white",
  },
]
export const PURCHASE_STATUS_EXPIRED = [
  {
    value: PURCHASE_STATUS_CANCELED_VALUE,
    label: PURCHASE_STATUS_EXPIRED_TEXT,
    color: PURCHASE_STATUS_CANCELED_COLOR,
    class: "hover:bg-custom-volcano hover:text-white",
  },
]
export const PURCHASE_STATUS_LINK_GENERATE = [
  {
    value: PURCHASE_STATUS_INCOMPLETE_VALUE,
    label: PURCHASE_STATUS_LINK_GENERATE_TEXT,
    color: PURCHASE_STATUS_LINK_GENERATE_COLOR,
    class: "hover:bg-custom-volcano hover:text-white",
  },
]

export const DELIVERY_TIMES = [
  { id: "00", start: "特定なし", end: null },
  { id: "01", start: "午前中", end: null },
  { id: "12", start: "12:00", end: "14:00" },
  { id: "14", start: "14:00", end: "16:00" },
  { id: "16", start: "16:00", end: "18:00" },
  { id: "18", start: "18:00", end: "20:00" },
  { id: "04", start: "18:00", end: "21:00" },
  { id: "19", start: "19:00", end: "21:00" },
]
// SHIPMENT CONSTANTS
export const SHIPMENT_STATUS_RECEIVED_VALUE = "received"
export const SHIPMENT_STATUS_RECEIVED_TEXT = "新規受付"
export const SHIPMENT_STATUS_RECEIVED_COLOR = "#69c0ff"
export const SHIPMENT_STATUS_PREPARING_VALUE = "preparing"
export const SHIPMENT_STATUS_PREPARING_TEXT = "商品準備中"
export const SHIPMENT_STATUS_PREPARING_COLOR = "#1890ff"
export const SHIPMENT_STATUS_SHIPPING_VALUE = "shipping"
export const SHIPMENT_STATUS_SHIPPING_TEXT = "発送準備中"
export const SHIPMENT_STATUS_SHIPPING_COLOR = "#13c2c2"
export const SHIPMENT_STATUS_COMPLETE_VALUE = "complete"
export const SHIPMENT_STATUS_COMPLETE_TEXT = "発送済"
export const SHIPMENT_STATUS_COMPLETE_COLOR = "#52c41a"
export const SHIPMENT_STATUS_CANCEL_VALUE = "cancel"
export const SHIPMENT_STATUS_CANCEL_TEXT = "取消"
export const SHIPMENT_STATUS_CANCEL_COLOR = "#fa541c"
export const SHIPMENT_STATUSES = [
  {
    value: SHIPMENT_STATUS_RECEIVED_VALUE,
    text: SHIPMENT_STATUS_RECEIVED_TEXT,
    color: SHIPMENT_STATUS_RECEIVED_COLOR,
    class: "hover:bg-custom-light-blue hover:text-white",
  },
  {
    value: SHIPMENT_STATUS_PREPARING_VALUE,
    text: SHIPMENT_STATUS_PREPARING_TEXT,
    color: SHIPMENT_STATUS_PREPARING_COLOR,
    class: "hover:bg-custom-blue hover:text-white",
  },
  {
    value: SHIPMENT_STATUS_SHIPPING_VALUE,
    text: SHIPMENT_STATUS_SHIPPING_TEXT,
    color: SHIPMENT_STATUS_SHIPPING_COLOR,
    class: "hover:bg-custom-cyan hover:text-white",
  },
  {
    value: SHIPMENT_STATUS_COMPLETE_VALUE,
    text: SHIPMENT_STATUS_COMPLETE_TEXT,
    color: SHIPMENT_STATUS_COMPLETE_COLOR,
    class: "hover:bg-custom-green hover:text-white",
  },
  {
    value: SHIPMENT_STATUS_CANCEL_VALUE,
    text: SHIPMENT_STATUS_CANCEL_TEXT,
    color: SHIPMENT_STATUS_CANCEL_COLOR,
    class: "hover:bg-custom-volcano hover:text-white",
  },
]

export const GET_SHIPMENT_STATUS_VALUE = (status) => {
  switch (status) {
    case SHIPMENT_STATUS_RECEIVED_VALUE:
      return SHIPMENT_STATUS_RECEIVED_TEXT
    case SHIPMENT_STATUS_PREPARING_VALUE:
      return SHIPMENT_STATUS_PREPARING_TEXT
    case SHIPMENT_STATUS_SHIPPING_VALUE:
      return SHIPMENT_STATUS_SHIPPING_TEXT
    case SHIPMENT_STATUS_COMPLETE_VALUE:
      return SHIPMENT_STATUS_COMPLETE_TEXT
    case SHIPMENT_STATUS_CANCEL_VALUE:
      return SHIPMENT_STATUS_CANCEL_TEXT
    default:
      return "ー"
  }
}

export const GET_SHIPMENT_STATUS_COLOR = (status) => {
  switch (status) {
    case SHIPMENT_STATUS_RECEIVED_VALUE:
      return SHIPMENT_STATUS_RECEIVED_COLOR
    case SHIPMENT_STATUS_PREPARING_VALUE:
      return SHIPMENT_STATUS_PREPARING_COLOR
    case SHIPMENT_STATUS_SHIPPING_VALUE:
      return SHIPMENT_STATUS_SHIPPING_COLOR
    case SHIPMENT_STATUS_COMPLETE_VALUE:
      return SHIPMENT_STATUS_COMPLETE_COLOR
    case SHIPMENT_STATUS_CANCEL_VALUE:
      return SHIPMENT_STATUS_CANCEL_COLOR
    default:
      return PRIMARY_COLOR
  }
}

export const GET_BUTTON_STYLE_BY_STATUS = (status) => {
  switch (status) {
    case SHIPMENT_STATUS_RECEIVED_VALUE:
      return "border-custom-light-blue text-custom-light-blue"
    case SHIPMENT_STATUS_PREPARING_VALUE:
      return "border-custom-blue text-custom-blue"
    case SHIPMENT_STATUS_SHIPPING_VALUE:
      return "border-custom-cyan text-custom-cyan"
    case SHIPMENT_STATUS_COMPLETE_VALUE:
      return "border-custom-green text-custom-green"
    case SHIPMENT_STATUS_CANCEL_VALUE:
      return "border-custom-volcano text-custom-volcano"
    default:
      return ""
  }
}

export const NOTIFICATION_TYPE_EMAIL_VALUE = "email"
export const NOTIFICATION_TYPE_EMAIL_TEXT = "メール送信"
export const NOTIFICATION_TYPE_LINE_VALUE = "line"
export const NOTIFICATION_TYPE_LINE_TEXT = "LINE送信"
export const NOTIFICATION_TYPES = [
  {
    value: NOTIFICATION_TYPE_EMAIL_VALUE,
    text: NOTIFICATION_TYPE_EMAIL_TEXT,
  },
  {
    value: NOTIFICATION_TYPE_LINE_VALUE,
    text: NOTIFICATION_TYPE_LINE_TEXT,
  },
]
//PAYMENT METHODS
export const ORDER_PAYMENT_METHOD_RAKUTENPAY = "rakutenPay"
export const ORDER_PAYMENT_METHOD_RAKUTENPAY_TEXT = "楽天ペイ"
export const ORDER_PAYMENT_METHOD_CREDIT_CARD = "creditCard"
export const ORDER_PAYMENT_METHOD_CREDIT_CARD_TEXT = "クレジットカード"
export const ORDER_PAYMENT_METHOD_CONVENIENCE_STORE = "convenienceStore"
export const ORDER_PAYMENT_METHOD_CONVENIENCE_STORE_TEXT = "コンビニ払い"
export const ORDER_PAYMENT_METHOD_IN_STORE = "inStore"
export const ORDER_PAYMENT_METHOD_IN_STORE_TEXT = "店舗支払い"
export const ORDER_PAYMENT_METHODS = [
  {
    value: ORDER_PAYMENT_METHOD_RAKUTENPAY,
    label: ORDER_PAYMENT_METHOD_RAKUTENPAY_TEXT,
  },
  {
    value: ORDER_PAYMENT_METHOD_CREDIT_CARD,
    label: ORDER_PAYMENT_METHOD_CREDIT_CARD_TEXT,
  },
  {
    value: ORDER_PAYMENT_METHOD_CONVENIENCE_STORE,
    label: ORDER_PAYMENT_METHOD_CONVENIENCE_STORE_TEXT,
  },
  {
    value: ORDER_PAYMENT_METHOD_IN_STORE,
    label: ORDER_PAYMENT_METHOD_IN_STORE_TEXT,
  },
]

// MAIL TEMPLATE CONSTANTS
export const REPLY_TEMPLATE_NEW_REGISTER_VALUE = "newRegister"
export const REPLY_TEMPLATE_NEW_REGISTER_TEXT =
  "会員登録完了\n【メール送信・LINE送信】"
export const REPLY_TEMPLATE_NEW_REGISTER_TITLE = "会員登録完了"

export const REPLY_TEMPLATE_FORGOT_PASSWORD_VALUE = "forgotPassword"
export const REPLY_TEMPLATE_FORGOT_PASSWORD_TEXT =
  "パスワード再設定\n【メール送信】"
export const REPLY_TEMPLATE_FORGOT_PASSWORD_TITLE = "パスワード再設定"

export const REPLY_TEMPLATE_PURCHASE_COMPLETE_VALUE = "purchaseComplete"
export const REPLY_TEMPLATE_PURCHASE_COMPLETE_TEXT =
  "注文完了（配達で受け取る）\n【メール送信・LINE送信】"
export const REPLY_TEMPLATE_PURCHASE_COMPLETE_TITLE =
  "注文完了（配達で受け取る）"

export const REPLY_TEMPLATE_LAYAWAY_COMPLETE_VALUE = "layawayComplete"
export const REPLY_TEMPLATE_LAYAWAY_COMPLETE_TEXT =
  "注文完了（店舗で受け取る）\n【メール送信・LINE送信】"
export const REPLY_TEMPLATE_LAYAWAY_COMPLETE_TITLE =
  "注文完了（店舗で受け取る）"

export const REPLY_TEMPLATE_SHIPMENT_COMPLETE_VALUE = "shipmentComplete"
export const REPLY_TEMPLATE_SHIPMENT_COMPLETE_TEXT =
  "発送完了\n【メール送信・LINE送信】"
export const REPLY_TEMPLATE_SHIPMENT_COMPLETE_TITLE = "発送完了"

export const REPLY_TEMPLATE_LAYAWAY_REMIND_VALUE = "layawayRemind"
export const REPLY_TEMPLATE_LAYAWAY_REMIND_TEXT =
  "店舗受け取りリマインド\n（前日18：00）\n【メール送信・LINE送信】"
export const REPLY_TEMPLATE_LAYAWAY_REMIND_TITLE =
  "店舗受け取りリマインド（前日18：00）"

export const REPLY_TEMPLATE_LAYAWAY_REMIND_BEFORE_11_VALUE =
  "layawayRemindBefore11"
export const REPLY_TEMPLATE_LAYAWAY_REMIND_BEFORE_11_TEXT =
  "店舗受け取りリマインド\n（当日1時間前・午前~16:00）\n【メール送信・LINE送信】"
export const REPLY_TEMPLATE_LAYAWAY_REMIND_BEFORE_11_TITLE =
  "店舗受け取りリマインド（当日1時間前・午前~16:00）"

export const REPLY_TEMPLATE_LAYAWAY_REMIND_BEFORE_17_VALUE =
  "layawayRemindBefore17"
export const REPLY_TEMPLATE_LAYAWAY_REMIND_BEFORE_17_TEXT =
  "店舗受け取りリマインド\n（当日1時間前・17:00~18:00）\n【メール送信・LINE送信】"
export const REPLY_TEMPLATE_LAYAWAY_REMIND_BEFORE_17_TITLE =
  "店舗受け取りリマインド（当日1時間前・17:00~18:00）"

export const REPLY_TEMPLATE_LAYAWAY_REMIND_BEFORE_18_VALUE =
  "layawayRemindBefore18"
export const REPLY_TEMPLATE_LAYAWAY_REMIND_BEFORE_18_TEXT =
  "店舗受け取りリマインド\n（当日1時間前・18:00~18:30）\n【メール送信・LINE送信】"
export const REPLY_TEMPLATE_LAYAWAY_REMIND_BEFORE_18_TITLE =
  "店舗受け取りリマインド（当日1時間前・18:00~18:30）"

export const REPLY_TEMPLATE_LAYAWAY_REMIND_AFTER_11_VALUE =
  "layawayRemindAfter11"
export const REPLY_TEMPLATE_LAYAWAY_REMIND_AFTER_11_TEXT =
  "店舗受け取りリマインド\n（当日1時間後・午前~16:00）\n【メール送信・LINE送信】"
export const REPLY_TEMPLATE_LAYAWAY_REMIND_AFTER_11_TITLE =
  "店舗受け取りリマインド（当日1時間後・午前~16:00）"

export const REPLY_TEMPLATE_LAYAWAY_REMIND_AFTER_17_VALUE =
  "layawayRemindAfter17"
export const REPLY_TEMPLATE_LAYAWAY_REMIND_AFTER_17_TEXT =
  "店舗受け取りリマインド\n（当日1時間後・17:00~18:00）\n【メール送信・LINE送信】"
export const REPLY_TEMPLATE_LAYAWAY_REMIND_AFTER_17_TITLE =
  "店舗受け取りリマインド（当日1時間後・17:00~18:00）"

export const REPLY_TEMPLATE_LAYAWAY_REMIND_AFTER_18_VALUE =
  "layawayRemindAfter18"
export const REPLY_TEMPLATE_LAYAWAY_REMIND_AFTER_18_TEXT =
  "店舗受け取りリマインド\n（当日1時間後・18:00~18:30）\n【メール送信・LINE送信】"
export const REPLY_TEMPLATE_LAYAWAY_REMIND_AFTER_18_TITLE =
  "店舗受け取りリマインド（当日1時間後・18:00~18:30）"

export const REPLY_TEMPLATES = [
  {
    value: REPLY_TEMPLATE_NEW_REGISTER_VALUE,
    text: REPLY_TEMPLATE_NEW_REGISTER_TEXT,
    title: REPLY_TEMPLATE_NEW_REGISTER_TITLE,
  },
  {
    value: REPLY_TEMPLATE_FORGOT_PASSWORD_VALUE,
    text: REPLY_TEMPLATE_FORGOT_PASSWORD_TEXT,
    title: REPLY_TEMPLATE_FORGOT_PASSWORD_TITLE,
  },
  {
    value: REPLY_TEMPLATE_PURCHASE_COMPLETE_VALUE,
    text: REPLY_TEMPLATE_PURCHASE_COMPLETE_TEXT,
    title: REPLY_TEMPLATE_PURCHASE_COMPLETE_TITLE,
  },
  {
    value: REPLY_TEMPLATE_LAYAWAY_COMPLETE_VALUE,
    text: REPLY_TEMPLATE_LAYAWAY_COMPLETE_TEXT,
    title: REPLY_TEMPLATE_LAYAWAY_COMPLETE_TITLE,
  },
  {
    value: REPLY_TEMPLATE_SHIPMENT_COMPLETE_VALUE,
    text: REPLY_TEMPLATE_SHIPMENT_COMPLETE_TEXT,
    title: REPLY_TEMPLATE_SHIPMENT_COMPLETE_TITLE,
  },
  {
    value: REPLY_TEMPLATE_LAYAWAY_REMIND_VALUE,
    text: REPLY_TEMPLATE_LAYAWAY_REMIND_TEXT,
    title: REPLY_TEMPLATE_LAYAWAY_REMIND_TITLE,
  },
  {
    value: REPLY_TEMPLATE_LAYAWAY_REMIND_BEFORE_11_VALUE,
    text: REPLY_TEMPLATE_LAYAWAY_REMIND_BEFORE_11_TEXT,
    title: REPLY_TEMPLATE_LAYAWAY_REMIND_BEFORE_11_TITLE,
  },
  {
    value: REPLY_TEMPLATE_LAYAWAY_REMIND_BEFORE_17_VALUE,
    text: REPLY_TEMPLATE_LAYAWAY_REMIND_BEFORE_17_TEXT,
    title: REPLY_TEMPLATE_LAYAWAY_REMIND_BEFORE_17_TITLE,
  },
  {
    value: REPLY_TEMPLATE_LAYAWAY_REMIND_BEFORE_18_VALUE,
    text: REPLY_TEMPLATE_LAYAWAY_REMIND_BEFORE_18_TEXT,
    title: REPLY_TEMPLATE_LAYAWAY_REMIND_BEFORE_18_TITLE,
  },
  {
    value: REPLY_TEMPLATE_LAYAWAY_REMIND_AFTER_11_VALUE,
    text: REPLY_TEMPLATE_LAYAWAY_REMIND_AFTER_11_TEXT,
    title: REPLY_TEMPLATE_LAYAWAY_REMIND_AFTER_11_TITLE,
  },
  {
    value: REPLY_TEMPLATE_LAYAWAY_REMIND_AFTER_17_VALUE,
    text: REPLY_TEMPLATE_LAYAWAY_REMIND_AFTER_17_TEXT,
    title: REPLY_TEMPLATE_LAYAWAY_REMIND_AFTER_17_TITLE,
  },
  {
    value: REPLY_TEMPLATE_LAYAWAY_REMIND_AFTER_18_VALUE,
    text: REPLY_TEMPLATE_LAYAWAY_REMIND_AFTER_18_TEXT,
    title: REPLY_TEMPLATE_LAYAWAY_REMIND_AFTER_18_TITLE,
  },
]

// TAX CONSTANTS //
export const TAX_ROUNDING_DIVISION_ROUND_VALUE = 0
export const TAX_ROUNDING_DIVISION_ROUND_TEXT = "四捨五入"
export const TAX_ROUNDING_DIVISION_FLOOR_VALUE = 1
export const TAX_ROUNDING_DIVISION_FLOOR_TEXT = "切り捨て"
export const TAX_ROUNDING_DIVISION_CEIL_VALUE = 2
export const TAX_ROUNDING_DIVISION_CEIL_TEXT = "切り上げ"
export const TAX_ROUNDING_DIVISIONS = [
  {
    value: TAX_ROUNDING_DIVISION_ROUND_VALUE,
    label: TAX_ROUNDING_DIVISION_ROUND_TEXT,
  },
  {
    value: TAX_ROUNDING_DIVISION_FLOOR_VALUE,
    label: TAX_ROUNDING_DIVISION_FLOOR_TEXT,
  },
  {
    value: TAX_ROUNDING_DIVISION_CEIL_VALUE,
    label: TAX_ROUNDING_DIVISION_CEIL_TEXT,
  },
]

export const TAX_SELL_DIVISION_INCLUSIVE_VALUE = 0
export const TAX_SELL_DIVISION_INCLUSIVE_TEXT = "内税販売"
export const TAX_SELL_DIVISION_EXCLUSIVE_VALUE = 1
export const TAX_SELL_DIVISION_EXCLUSIVE_TEXT = "外税販売"

export const TAX_SELL_DIVISIONS = [
  {
    value: TAX_SELL_DIVISION_INCLUSIVE_VALUE,
    label: TAX_SELL_DIVISION_INCLUSIVE_TEXT,
  },
  {
    value: TAX_SELL_DIVISION_EXCLUSIVE_VALUE,
    label: TAX_SELL_DIVISION_EXCLUSIVE_TEXT,
  },
]

export const TAX_DIVISION_IN_VALUE = 0
export const TAX_DIVISION_IN_TEXT = "税込"
export const TAX_DIVISION_EX_VALUE = 1
export const TAX_DIVISION_EX_TEXT = "税抜"

//POINT CONSTANTS
export const POINT_GIVING_DIVISIONS_TA_IN_PO_IN_VALUE = 1
export const POINT_GIVING_DIVISIONS_TA_IN_PO_IN_TEXT =
  "税額を含める + 利用ポイント分を含める"
export const POINT_GIVING_DIVISIONS_TA_EX_PO_IN_VALUE = 2
export const POINT_GIVING_DIVISIONS_TA_EX_PO_IN_TEXT =
  "税額を含めない + 利用ポイント分を含める"
export const POINT_GIVING_DIVISIONS_TA_IN_PO_EX_VALUE = 3
export const POINT_GIVING_DIVISIONS_TA_IN_PO_EX_TEXT =
  "税額を含める + 利用ポイント分を含めない"
export const POINT_GIVING_DIVISIONS_TA_EX_PO_EX_VALUE = 4
export const POINT_GIVING_DIVISIONS_TA_EX_PO_EX_TEXT =
  "税額を含めない + 利用ポイント分を含めない"

export const POINT_GIVING_DIVISIONS = [
  {
    value: POINT_GIVING_DIVISIONS_TA_IN_PO_IN_VALUE,
    label: POINT_GIVING_DIVISIONS_TA_IN_PO_IN_TEXT,
  },
  {
    value: POINT_GIVING_DIVISIONS_TA_EX_PO_IN_VALUE,
    label: POINT_GIVING_DIVISIONS_TA_EX_PO_IN_TEXT,
  },
  {
    value: POINT_GIVING_DIVISIONS_TA_IN_PO_EX_VALUE,
    label: POINT_GIVING_DIVISIONS_TA_IN_PO_EX_TEXT,
  },
  {
    value: POINT_GIVING_DIVISIONS_TA_EX_PO_EX_VALUE,
    label: POINT_GIVING_DIVISIONS_TA_EX_PO_EX_TEXT,
  },
]

export const convertToNumber = (value) => {
  return Number(value) || 0
}

export const calculateByRoundMethod = (value) => {
  return Math.round(convertToNumber(value))
}

export const calculateByFloorMethod = (value) => {
  return Math.floor(convertToNumber(value))
}

export const calculateByCeilMethod = (value) => {
  return Math.ceil(convertToNumber(value))
}

export const getTaxRate = (settings) => {
  if (settings?.taxRate?.valueNumber === undefined) {
    return 0
  }

  return convertToNumber(settings.taxRate.valueNumber) / 100
}

export const getRoundedPrice = (settings, amount) => {
  if (!amount) {
    return 0
  }

  if (settings?.taxRoundingDivision?.valueNumber === undefined) {
    return convertToNumber(amount)
  }

  switch (settings.taxRoundingDivision.valueNumber) {
    case TAX_ROUNDING_DIVISION_ROUND_VALUE:
      return calculateByRoundMethod(amount)
    case TAX_ROUNDING_DIVISION_FLOOR_VALUE:
      return calculateByFloorMethod(amount)
    case TAX_ROUNDING_DIVISION_CEIL_VALUE:
      return calculateByCeilMethod(amount)
    default:
      return convertToNumber(amount)
  }
}

export const getTaxAmount = (arg) => {
  const { settings, value, includeRounding } = arg || {}

  if (!value) {
    return 0
  }

  if (!settings || settings?.taxRate?.valueNumber === undefined) {
    return 0
  }

  const taxAmount = convertToNumber(value) * getTaxRate(settings)

  if (includeRounding) {
    return getRoundedPrice(settings, taxAmount)
  } else {
    return taxAmount
  }
}

export const getHistoryProductTotal = (arg) => {
  const { price, quantity, taxDivision, sellDivision, taxRate, taxRounding } =
    arg || {}

  if (price === undefined) {
    return 0
  }

  if (quantity === undefined) {
    return price
  }

  if (taxDivision === undefined) {
    return price
  }

  if (sellDivision === undefined) {
    return price
  }

  if (taxRate === undefined) {
    return price
  }

  if (taxRounding === undefined) {
    return price
  }

  const settings = {
    taxRate: { valueNumber: taxRate },
    taxRoundingDivision: { valueNumber: taxRounding },
  }

  if (taxDivision === TAX_DIVISION_IN_VALUE) {
    return convertToNumber(price) * convertToNumber(quantity)
  } else if (taxDivision === TAX_DIVISION_EX_VALUE) {
    switch (sellDivision) {
      case TAX_SELL_DIVISION_INCLUSIVE_VALUE:
        return (
          (convertToNumber(price) +
            getTaxAmount({ settings, value: price, includeRounding: true })) *
          convertToNumber(quantity)
        )
      case TAX_SELL_DIVISION_EXCLUSIVE_VALUE:
        return (
          convertToNumber(price) * convertToNumber(quantity) +
          getTaxAmount({
            settings,
            value: convertToNumber(price) * convertToNumber(quantity),
            includeRounding: true,
          })
        )
      default:
        return price
    }
  } else {
    return price
  }
}

export const getHistoryOrderSubtotal = (arg) => {
  const { subTotal, totalTax, sellDivision } = arg || {}

  if (!subTotal) {
    return 0
  }

  if (
    sellDivision === undefined ||
    sellDivision === TAX_SELL_DIVISION_INCLUSIVE_VALUE
  ) {
    return subTotal
  }

  return Number(subTotal) + Number(totalTax || 0)
}

export const CONVERT_POINT_TO_CURRENCY = (arg) => {
  const { pointSettings, points } = arg || {}

  if (pointSettings?.spendRate && Number(pointSettings?.spendRate)) {
    return Number(pointSettings?.spendRate) * points
  } else {
    return 0
  }
}

/* CHECK MOUNTED REACT */
export function USE_IS_MOUNTED_REF() {
  const isMountedRef = useRef(null)

  useEffect(() => {
    isMountedRef.current = true
    return () => (isMountedRef.current = false)
  })

  return isMountedRef
}

export const RE_ORDER = (list, startIndex, endIndex) => {
  const result = Array.from(list)
  const [removed] = result.splice(startIndex, 1)
  result.splice(endIndex, 0, removed)

  return result
}

export function GET_BASE_64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => resolve(reader.result)
    reader.onerror = (error) => reject(error)
  })
}

export function INSERT_CHARACTER(str, index, value) {
  return str.substr(0, index) + value + str.substr(index)
}

export class NUMERIC_INPUT extends React.Component {
  onChange = (e) => {
    const { value } = e.target
    const reg = /^-?\d*(\.\d*)?$/

    if ((!isNaN(value) && reg.test(value)) || value === "" || value === "-") {
      this.props.onChange(value)
    }
  }

  render() {
    return (
      <Input
        {...this.props}
        onChange={this.onChange}
        onPressEnter={(e) => e.preventDefault()}
      />
    )
  }
}
